import 'leaflet-gesture-handling/dist/leaflet-gesture-handling.css';
import 'leaflet/dist/leaflet.css';
import { forwardRef } from 'react';

import dynamic from 'next/dynamic';

import { useLeafletMapContext } from './LeafletContext';
import type {
  LeafletComponentType,
  LeafletMapProps,
  LeafletType,
} from './LeafletMap';

const DynamicLeafletMap = dynamic(() => import('./LeafletMap'), {
  ssr: false,
}) as LeafletComponentType;

const LeafletMap = forwardRef<
  LeafletType,
  LeafletMapProps & { gestureHandling?: boolean }
>((props, ref) => {
  return <DynamicLeafletMap {...props} mapReference={ref} />;
});

LeafletMap.displayName = 'LeafletMap';

export type {
  LeafletMapProps,
  LeafletTotalType,
  LeafletType,
  ReactLeafletTotalType,
} from './LeafletMap';
export { LeafletMap, useLeafletMapContext };
